import React from 'react';

const GradientCard = ({ text, description }) => {
  const hostname = window.location.hostname; // ví dụ: 'shopxulaohac.vn'

  const desc = description.replace('{hostname}', hostname);

  return (
    <div className="max-w-7xl mx-2 py-0 mb-0">
      <div className="relative group">
        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
        <div className="relative px-3 py-1 bg-gradient-to-r from-blue-100 to-pink-200 hover:from-pink-400 hover:to-yellow-300 ring-1 ring-gray-900/5 rounded-2xl leading-none flex items-top justify-start space-x-3">
          <div className="mb-3 mt-1 space-y-1">
            <div className="text-lg text-pink-400 font-bold">
              {text}
            </div>
            <div className="block text-indigo-400 group-hover:text-slate-800 transition duration-200">
              {desc}
            </div>
            <span className="absolute rounded-2xl inset-x-0 bottom-0 h-2 bg-gradient-to-r from-green-300 via-blue-500 to-purple-600"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradientCard;